import { forwardRef, memo } from "react";

export const SMSNotificationIcon = memo(
  forwardRef(function SMSNotificationIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M16.0424 20.0528H6.60574C3.16138 20.0528 1.17969 18.0711 1.17969 14.6268V8.02115C1.17969 4.57678 3.16138 2.59509 6.60574 2.59509H13.2114C13.5983 2.59509 13.9191 2.91594 13.9191 3.30284C13.9191 3.68974 13.5983 4.01059 13.2114 4.01059H6.60574C3.90687 4.01059 2.59518 5.32228 2.59518 8.02115V14.6268C2.59518 17.3257 3.90687 18.6373 6.60574 18.6373H16.0424C18.7412 18.6373 20.0529 17.3257 20.0529 14.6268V9.90847C20.0529 9.52157 20.3738 9.20073 20.7607 9.20073C21.1476 9.20073 21.4684 9.52157 21.4684 9.90847V14.6268C21.4684 18.0711 19.4867 20.0528 16.0424 20.0528Z"
          fill={color}
        />
        <path
          d="M11.3231 12.145C10.5305 12.145 9.72836 11.8996 9.11498 11.3995L6.16131 9.04034C5.85934 8.79499 5.80272 8.35147 6.04808 8.04949C6.29343 7.74752 6.73694 7.69091 7.03891 7.93626L9.99258 10.2954C10.7098 10.871 11.9271 10.871 12.6443 10.2954L13.7578 9.40837C14.0598 9.16302 14.5127 9.2102 14.7486 9.5216C14.994 9.82358 14.9468 10.2765 14.6354 10.5125L13.5219 11.3995C12.9179 11.8996 12.1158 12.145 11.3231 12.145Z"
          fill={color}
        />
        <path
          d="M18.4028 8.25709C16.7137 8.25709 15.3359 6.87935 15.3359 5.19019C15.3359 3.50104 16.7137 2.12329 18.4028 2.12329C20.092 2.12329 21.4697 3.50104 21.4697 5.19019C21.4697 6.87935 20.092 8.25709 18.4028 8.25709ZM18.4028 3.53878C17.4969 3.53878 16.7514 4.28428 16.7514 5.19019C16.7514 6.09611 17.4969 6.8416 18.4028 6.8416C19.3088 6.8416 20.0542 6.09611 20.0542 5.19019C20.0542 4.28428 19.3088 3.53878 18.4028 3.53878Z"
          fill={color}
        />
      </svg>
    );
  }),
);

SMSNotificationIcon.displayName = "SMSNotificationIcon";